export enum ReadMode {
  arrayBuffer,
  binaryString,
  dataURL,
  text
}
